// extracted by mini-css-extract-plugin
export var pillWrapper = "_hi-0";
export var showOverflow = "_hi-1";